import React, { useRef, useEffect } from 'react';
import { Table, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from "react-redux";
import Loader from "react-loader-spinner";
import { X, Search } from 'react-bootstrap-icons';
import { setSelectStaffPopup, getRelatedStaffsToAgent, getAgentList } from "../../store/api/Services";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
const ModalSelectStaff = () => {
    const searchData = useRef({});
    const selectStaffPopup = useSelector(state => state.service.selectStaffPopup);
    const { relatedStaffs, agentList } = useSelector(state => { return { relatedStaffs: state.service.relatedStaffs, agentList: state.service.agentList } })
    const dispatch = useDispatch();
    const { status, onSelect } = selectStaffPopup;

    const cancel = () => {
        onSelect(null);
        dispatch(setSelectStaffPopup({ status: 'hide' }));
    }
    const selectStaff = (item) => {
        onSelect(item);
        dispatch(setSelectStaffPopup({ status: 'hide' }));
    }
    const search = () => {
        searchData.current.Take = 5;
        if (selectStaffPopup.forAgency) {
            dispatch(getAgentList(searchData.current));
        }
        else {
            dispatch(getRelatedStaffsToAgent(searchData.current));
        }
    }
    return (
        <Modal show={status === "show"} style={{ direction: "rtl" }} onHide={() => { }}>
            <Modal.Header className='headerStyle'>{"انتخاب " + (selectStaffPopup.forAgency ? "نماینده" : "تکنسین")}<FontAwesomeIcon icon={faTimes} size='lg' onClick={cancel} style={{ cursor: "pointer" }} /></Modal.Header>
            <Modal.Body className='bodyStyle'>
                <div className='row' style={{ marginLeft: "2px", marginRight: "2px" }}>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder='کد تکنسین/نماینده' type="text" className='form-control' onChange={(e) => searchData.current.Code = e.target.value} />
                    </div>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder='نام تکنسین/نماینده' type="text" className='form-control' onChange={(e) => searchData.current.Name = e.target.value} />
                    </div>
                    <div className='form-group col-md-4' style={{ padding: "1px" }}>
                        <input placeholder='موبایل تکنسین/نماینده' type="text" className='form-control' onChange={(e) => searchData.current.Mobile = e.target.value} />
                    </div>
                    <Button className="mt-2 mb-2" onClick={search}><Search size={20} />جستجو</Button>
                </div>
                <Table>
                    <thead>
                        <tr>
                            <th style={{ display: "none" }}></th>
                            <th>{"کد " + (selectStaffPopup.forAgency ? "نماینده" : "تکنسین")}</th>
                            <th>{"نام " + (selectStaffPopup.forAgency ? "نماینده" : "تکنسین")}</th>
                            <th>موبایل</th>
                        </tr>
                    </thead>
                    <tbody>
                        {(selectStaffPopup.forAgency && agentList && agentList === "PENDING") || (!selectStaffPopup.forAgency && relatedStaffs === "PENDING") &&
                            <tr>
                                <td colSpan={3} style={{ textAlign: "center" }}>
                                    <Loader type="BallTriangle" color="#bb1370" height={30} width={30} />
                                </td>
                            </tr>
                        }
                        {!selectStaffPopup.forAgency && relatedStaffs && Array.isArray(relatedStaffs) &&
                            relatedStaffs.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => selectStaff(item)}>
                                    <td style={{ display: "none" }}></td>
                                    <td>{item.Code}</td>
                                    <td>{item.LastName}</td>
                                    <td>{item.Mobile}</td>
                                </tr>
                            )
                        }
                        {selectStaffPopup.forAgency && agentList && Array.isArray(agentList) &&
                            agentList.map((item, i) =>
                                <tr key={i} className="resultTableRow" onClick={() => selectStaff(item)}>
                                    <td style={{ display: "none" }}></td>
                                    <td>{item.Code}</td>
                                    <td>{item.LastName}</td>
                                    <td>{item.Mobile}</td>
                                </tr>
                            )
                        }
                    </tbody>
                </Table>
            </Modal.Body>
        </Modal>
    )
}
export default ModalSelectStaff;